import { fromJS } from 'immutable';

import { requestGraphql } from '@/lib/backend';
import { derivedTitle } from './data/annotation';

import UpdateAnnotationMutation from './queries/UpdateAnnotationMutation';

export default async function updateAnnotation(
  session,
  graphql,
  pathname,
  dispatch,
  router,
  annotationsRenderer,
  story,
  annotation,
  annotationAttributes,
  options?: { skipRedraw?: boolean; shouldRefreshRouter?: boolean }
) {
  const { data, error } = await requestGraphql(
    session,
    graphql,
    pathname,
    UpdateAnnotationMutation,
    'updateAnnotation',
    {
      ...annotationAttributes,
      story_id: story.get('id'),
      annotation_id: annotation.get('id'),
    },
    'Annotation Update',
    {
      storyId: story.get('id'),
      storySlug: story.get('slug'),
      annotationId: annotation.get('id'),
    }
  );

  if (error) {
    dispatch({
      type: 'setFlashMessage',
      data: {
        type: 'error',
        message: error.errorMessage,
      },
    });

    return;
  }

  const updatedAnnotation = fromJS(data);

  if (!options?.skipRedraw) {
    annotationsRenderer.redrawSingleAnnotation(
      annotation.get('id'),
      derivedTitle(updatedAnnotation),
      data
    );
  }

  if (options?.shouldRefreshRouter) {
    router.refresh();
  }
}
